var render = function render(){var _vm=this,_c=_vm._self._c;return _c('settings-wrapper',{attrs:{"title":"Organization settings","section":"Secrets"}},[_c('secrets-listing',{attrs:{"level":3}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }